(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-italia-collections"] && !Shopify.designMode) return;
  try {
    
  class CasaCollectionsCarousel {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector('[data-casa-carousel]');
      this.prev = section.querySelector('[data-casa-prev]');
      this.next = section.querySelector('[data-casa-next]');

      if (!this.carousel || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scroll(-1));
      this.next.addEventListener('click', () => this.scroll(1));
      this.carousel.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());
      this.updateButtons();
    }

    scroll(direction) {
      const firstCard = this.carousel.querySelector('.casa-collection-item');
      const gap = parseFloat(window.getComputedStyle(this.carousel).columnGap || 0);
      const distance = firstCard ? firstCard.offsetWidth + gap : this.carousel.clientWidth;

      this.carousel.scrollBy({
        left: direction * distance,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      const maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth - 1;
      this.prev.disabled = this.carousel.scrollLeft <= 1;
      this.next.disabled = this.carousel.scrollLeft >= maxScroll;
    }
  }

  document.querySelectorAll('[data-casa-collections]').forEach((section) => {
    new CasaCollectionsCarousel(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
